import { useCallback, useEffect, useRef, useState } from "react";

export default function useSafeState<T>(initialValue: T) {
  const [state, setState] = useState(initialValue);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const safeSetState = useCallback((value: T) => {
    if (mountedRef.current) {
      setState(value);
    }
  }, []);

  return [state, safeSetState] as const;
}
